// @tennis-matches/core/constants/regeltermine
// Kanonische Serientermine-URLs (Produktmarke). Intern bleibt appKey/route „winterdoppel“.
// Legacy-Aliase: regeltermine, winterdoppel.

/** Kanonisches erstes URL-Segment */
export const REGELTERMINE_CANONICAL_SEGMENT = "serientermine";

/** Kanonischer Pfad-Präfix (ohne trailing slash) */
export const REGELTERMINE_PATH_PREFIX = "/serientermine";

/** Hub-Landing für Serientermine */
export const REGELTERMINE_HUB_PATH = "/hub/serientermine";

/**
 * Erstes URL-Segment → internes Route-Segment (weiterhin „winterdoppel“).
 * @type {Readonly<Record<string, string>>}
 */
export const REGELTERMINE_URL_SEGMENT_ALIASES = Object.freeze({
  serientermine: "winterdoppel",
  regeltermine: "winterdoppel",
  winterdoppel: "winterdoppel",
});

/** Hub-Subpfade, die auf die Serientermine-App zeigen */
export const REGELTERMINE_HUB_SUB_SEGMENTS = Object.freeze([
  "serientermine",
  "regeltermine",
  "winterdoppel",
]);

/**
 * @param {string} suffix — optionaler Restpfad ohne führenden Slash
 * @returns {string}
 */
export function buildRegelterminePath(suffix = "") {
  const rest = String(suffix || "").replace(/^\/+/, "");
  return rest
    ? `${REGELTERMINE_PATH_PREFIX}/${rest}`
    : REGELTERMINE_PATH_PREFIX;
}

/**
 * Relativer Pfad innerhalb Serientermine (z. B. `/schedule/…`).
 * Gibt `""` für App-Root, `null` wenn kein Serientermine-Pfad.
 *
 * @param {string} pathname
 * @returns {string|null}
 */
export function getRegelterminePathSuffix(pathname) {
  const p =
    String(pathname || "")
      .split("?")[0]
      .replace(/\/+$/, "") || "/";
  const segs = p.replace(/^\/+/, "").split("/").filter(Boolean);
  if (!segs.length) return null;

  if (segs[0] === "hub" && REGELTERMINE_HUB_SUB_SEGMENTS.includes(segs[1])) {
    return segs.length > 2 ? `/${segs.slice(2).join("/")}` : "";
  }

  if (REGELTERMINE_URL_SEGMENT_ALIASES[segs[0]] === "winterdoppel") {
    return segs.length > 1 ? `/${segs.slice(1).join("/")}` : "";
  }

  return null;
}

/**
 * @param {string} pathname
 * @returns {boolean}
 */
export function isRegelterminePathname(pathname) {
  return getRegelterminePathSuffix(pathname) != null;
}
